import * as React from 'react';
import Tag from '../Tag';
import './styles.scss';

interface TagProps {
  tags: {
    text: string;
    url: string;
  }[];
}

const TagList = ({ tags }: TagProps) => (
  <ul className="tag-list">
    {tags.map((tag) => (
      <li className="tag-list__item">
        <Tag {...tag} />
      </li>
    ))}
  </ul>
);

export default TagList;
